var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { styled, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { AudioFrameIcon, BluePauseIconNew } from "../../../assets/images";
import { showNotification } from "../../../redux/commonSlice";
import { useAppDispatch } from "../../../store/hooks";
import { convertBlobToWav, formatTime, GoogleAnlyticsErrorLog } from "../../../utils/utils";
import { MuiStack } from "../../atoms/stackComponent";
import { AudioButtonIcon } from "../../../assets/customIcons";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "20px",
        width: "20px"
    };
});
export var AudioComponent = function (props) {
    var _a = props.draftJc, draftJc = _a === void 0 ? false : _a, isdisablebtn = props.isdisablebtn;
    var dispatch = useAppDispatch();
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var _b = useState(0), audioDuration = _b[0], setAudioDuration = _b[1];
    var _c = useState(null), audioUrl = _c[0], setAudioUrl = _c[1];
    var _d = useState(null), stream = _d[0], setStream = _d[1];
    var mediaRecorder = useRef(null);
    var audio = new Audio(audioUrl !== null && audioUrl !== void 0 ? audioUrl : '');
    var _e = useState([]), audioChunks = _e[0], setAudioChunks = _e[1];
    var _f = useState(false), isPlaying = _f[0], setIsPlaying = _f[1];
    useEffect(function () {
        var interval;
        if (isPlaying) {
            var startTime_1 = Date.now();
            interval = setInterval(function () {
                setAudioDuration(Math.floor((Date.now() - startTime_1) / 1000));
            }, 1000);
        }
        return function () {
            clearInterval(interval);
        };
    }, [isPlaying]);
    var startRecording = function () {
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then(function (stream) {
            setStream(stream);
            // create media recorder instance to initialize recording
            mediaRecorder.current = new MediaRecorder(stream);
            if (stream) {
                setIsPlaying(true);
                var containers = ['webm', 'ogg', 'mp4', 'x-matroska', '3gpp', '3gpp2', '3gp2', 'quicktime', 'mpeg', 'aac', 'flac', 'wav'];
                var supportedAudios = containers.map(function (format) { return "audio/".concat(format); }).filter(function (item) { return MediaRecorder.isTypeSupported(item); });
                if (supportedAudios.length > 0) {
                    var media = new MediaRecorder(stream, {
                        mimeType: supportedAudios[0]
                    });
                    mediaRecorder.current = media;
                    //invokes the start method to start the recording process
                    mediaRecorder.current.start();
                    var localAudioChunks_1 = [];
                    mediaRecorder.current.ondataavailable = function (event) {
                        if (typeof event.data === "undefined")
                            return;
                        if (event.data.size === 0)
                            return;
                        localAudioChunks_1.push(event.data);
                    };
                    setAudioChunks(localAudioChunks_1);
                }
                else {
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Audio not supported by browser");
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Audio not supported by browser",
                        type: "error"
                    }));
                }
            }
        }).catch(console.error);
    };
    var stopRecording = function () {
        setIsPlaying(false);
        //stops the recording instance
        if (mediaRecorder && mediaRecorder.current && mediaRecorder.current.state === 'recording') {
            setIsPlaying(false);
            mediaRecorder.current.stop();
            mediaRecorder.current.onstop = function () { return __awaiter(void 0, void 0, void 0, function () {
                var audioBlob, convertedBlob, audioUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            audioBlob = new Blob(audioChunks, {
                                type: 'audio/mp4'
                            });
                            return [4 /*yield*/, convertBlobToWav(audioBlob)];
                        case 1:
                            convertedBlob = _a.sent();
                            audioUrl = URL.createObjectURL(audioBlob);
                            setAudioUrl(audioUrl);
                            props.handleurl(audioUrl, audioDuration, convertedBlob);
                            setAudioChunks([]);
                            setAudioDuration(0);
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        ;
    };
    var getDuration = function () {
        audio.currentTime = 0;
        audio.removeEventListener('timeupdate', getDuration);
        setAudioDuration(audio.duration);
    };
    // useEffect(() => {
    //     if (audioUrl) {
    //         audio.currentTime = 1e101
    //         audio.addEventListener('loadedmetadata', () => {
    //             if (audio.duration === Infinity || isNaN(Number(audio.duration))) {
    //                 audio.addEventListener('timeupdate', getDuration)
    //             }
    //         })
    //         setAudioDuration(audio.duration)
    //     }
    // }, [audioUrl])
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        spacing: 2
    }, !isPlaying ? props.isDisablebtn ?
        /*#__PURE__*/
        // <Img src={BlueMikeIconDisabled} />
        React.createElement(AudioButtonIcon, {
            sx: {
                stroke: systemColor.disabled
            }
        }) : /*#__PURE__*/ React.createElement(AudioButtonIcon, {
        onClick: startRecording,
        sx: {
            stroke: systemColor.primary
        }
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Img, {
        onClick: stopRecording,
        id: "stopRecording",
        src: BluePauseIconNew,
        alt: "audioplayicon"
    }), /*#__PURE__*/ React.createElement(Img, {
        src: AudioFrameIcon,
        alt: "audioplayicon",
        style: {
            width: '78px',
            height: '20px'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#1B1D21',
            marginLeft: "5px"
        }
    }, formatTime(audioDuration)))), /*#__PURE__*/ React.createElement("audio", {
        src: audioUrl !== null && audioUrl !== void 0 ? audioUrl : ""
    }));
};
